import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// Service de Apontamentos de Tarefas (Fase 5 Etapa 3)
// ────────────────────────────────────────────────────────────────────────────
// Cada apontamento gera AUTOMATICAMENTE um bloco no calendário do colaborador
// (tipo='TAREFA'). O backend faz isso de forma atômica. O frontend só
// dispara a operação e exibe.
//
// Detecção de conflito: ao criar/alterar, se já há outro bloco no horário,
// o backend retorna HTTP 409 com `{ conflitos, requer_confirmacao: true }`.
// Caller deve perguntar ao usuário e reenviar com `force=true`.
// ════════════════════════════════════════════════════════════════════════════

const apontamentoService = {

  // Lista apontamentos de uma tarefa (próprios da tarefa, sem descendentes)
  listar: async (tarefaId) => {
    const res = await api.get(`/tarefas/${tarefaId}/apontamentos`);
    return res.data;
  },

  // Resumo de horas (próprias + filhas) — usado pra badges
  resumo: async (tarefaId) => {
    const res = await api.get(`/tarefas/${tarefaId}/apontamentos-resumo`);
    return res.data;
  },

  // Cria apontamento. dados = { data_inicio, data_fim, descricao? }
  // Em caso de conflito, backend retorna 409 — caller pode reenviar com force=true.
  incluir: async (tarefaId, dados, usuario_id, force = false) => {
    const res = await api.post(`/tarefas/${tarefaId}/apontamentos`, {
      ...dados, usuario_id, force,
    });
    return res.data;
  },

  // Altera. dados = { data_inicio, data_fim, descricao? }
  alterar: async (apontamentoId, dados, usuario_id, force = false) => {
    const res = await api.put(`/apontamentos/${apontamentoId}`, {
      ...dados, usuario_id, force,
    });
    return res.data;
  },

  // Exclui (soft delete + cascade no bloco do calendário)
  excluir: async (apontamentoId, usuario_id) => {
    const res = await api.delete(`/apontamentos/${apontamentoId}`, {
      data: { usuario_id },
    });
    return res.data;
  },

  // Resolve o colaborador vinculado ao usuário logado
  meuColaborador: async (usuario_id) => {
    const res = await api.get(`/apontamentos/meu-colaborador`, {
      params: { usuario_id },
    });
    return res.data;
  },
};

export default apontamentoService;
